import { coerceCssPixelValue } from '@angular/cdk/coercion';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { MaterialModule } from '@lockton-apps/material';
import { UiModule } from '@lockton-apps/shared/ui/lui';

@Component({
    selector: 'la-password-requirements',
    imports: [CommonModule, MaterialModule, UiModule],
    templateUrl: './password-requirements.component.html',
    styleUrls: ['./password-requirements.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordRequirementsComponent implements OnInit {
  @Input() anchor!: HTMLElement;
  @Input() control!: FormControl;
  @Input() open = false;

  positions: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top',
      panelClass: 'panel-below',
      offsetY: -20,
    },
    {
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'bottom',
      offsetY: -16,

      panelClass: 'panel-above',
    },
  ];

  get panelWidth() {
    if (!this.anchor) {
      return 200;
    }
    return coerceCssPixelValue(this.anchor.getBoundingClientRect().width);
  }

  private destroy = new Subject<void>();

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy))
      .subscribe(() => this.cd.markForCheck());
  }
}
